<template>
    <div class="coming-soon">{{ $t("wp.comingSoon") }}</div>
</template>

<script>
export default {
    name: "ComingSoonWrapper",
};
</script>

<style>
.coming-soon {
    position: absolute;

    z-index: 1;

    width: 100%;

    height: 100%;

    display: flex;

    justify-content: center;

    align-items: center;

    background-color: rgba(0, 0, 0, 0.3);

    color: white;

    font-size: 20px;

    font-weight: bold;

    letter-spacing: 2px;
}
</style>
